import LoadPanel from 'app/components/LoadPanel';
import WrapContent from 'app/components/WrapContent/WrapContent';
import useDictionary from 'hooks/useDictionary';
import React from 'react';
import '../HomePage/styles.scss';

export function HomePage() {
  const { t } = useDictionary({});

  return (
    <>
      <WrapContent>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={false} />
          <div
            className="title-page"
            style={{ marginTop: 0, lineHeight: '25px' }}
          >
            {t('Home Page')}
          </div>
          <div className="home-page-content"></div>
        </React.Suspense>
      </WrapContent>
    </>
  );
}
